import _ from 'lodash';

export function endBalance(documents: any[]) {
  return _.get(documents[documents.length - 1], 'endBalance', 0);
}